import type { SxProps, Theme } from '@mui/material/styles';

import { Box } from 'ui/box';

import CriticalElementRowSkeleton from 'containers/user/critical-elements-monitoring/components/critical-element-row-skeleton';

const ROW_PLACEHOLDER_SX = [
  { name: { width: '260px' }, meta: { width: '340px' } },
  { name: { width: '300px' }, meta: { width: '280px' } },
  { name: { width: '220px' }, meta: { width: '360px' } },
] satisfies Record<'name' | 'meta', SxProps<Theme>>[];

const CriticalElementsRosterSkeleton = () => (
  <Box role="status" data-testid="critical-elements-roster-skeleton">
    <span className="sr-only">Loading critical elements</span>
    <div className="flex animate-pulse flex-col gap-2" aria-hidden="true">
      {ROW_PLACEHOLDER_SX.map((widths, index) => (
        <CriticalElementRowSkeleton
          key={index}
          nameSx={widths.name}
          metaSx={widths.meta}
        />
      ))}
    </div>
  </Box>
);

export default CriticalElementsRosterSkeleton;
